<div class='main-nav'>

	<div class='navbar navbar-inverse'>

		<div class='navbar-header'>
			<a class="navbar-brand" style="float: none; height: auto; padding-top: 0px; padding-bottom: 0px;" [routerLink]="'/networks'">
				<img src="/assets/UVexplorerServerLogo-White.png" class="logo" />
			</a>
		</div>

		<profile class="profile"></profile>

		<div style="width:100%;">
			<!-- List of networks -->
			<nav-tree></nav-tree>
		</div>



	</div>

</div>
